// extracted by mini-css-extract-plugin
export default {"root":"kgUo4B","mobile":"nrTfJh"};